import * as React from 'react';
import { Grid, Dialog, DialogTitle, DialogContent, DialogActions } from '@material-ui/core';
import { withStyles, StyledComponentProps } from '@material-ui/core/styles';
import { IMediaQueryProps, WithMediaQuery } from '../../../layout/withMediaQuery';
import { room, emptyRoom } from '../../../model/room';
import ConfirmButton from '../../../ui-components/Button/ConfirmButton';
import CancelButton from '../../../ui-components/Button/CancelButton';
import { styles } from "../styles"
import TextField from '../../../ui-components/TextField/TextField';

interface IProps extends IMediaQueryProps, IInnerProps {

}

interface IInnerProps extends StyledComponentProps {
    onConfirm: (room: room) => any;
    onCancel: () => any;
    open: boolean;
}
interface IState {
    newRoom: room;
}


class AddRoomDialog extends React.Component<IProps, IState> {

    /**
     *
     */
    constructor(p, c) {
        super(p, c);
        this.state = {
            newRoom: emptyRoom(),
        }
    }

    componentDidUpdate(prevProps: IProps) {
        if (!prevProps.open && this.props.open) {
            this.setState({
                newRoom: emptyRoom(),
            })
        }
    }

    checkRoomInvalid = () => {
        var res = (this.state.newRoom.code !== undefined && this.state.newRoom.code !== null && this.state.newRoom.code.trim() !== "")
            && (this.state.newRoom.description !== undefined && this.state.newRoom.description !== null && this.state.newRoom.description.trim() !== "")
        return res;
    }


    updateRoom = (room: room) => {
        this.setState({
            newRoom: room,
        });
    }



    render() {
        console.log(this.checkRoomInvalid())
        return (
            <Dialog
                open={this.props.open}
                onClose={(e) => this.props.onCancel()}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                {<DialogTitle id="alert-dialog-title">Aggiungi Room</DialogTitle>}
                < DialogContent className={this.props.classes.reservationSlotDetailDialogContent} >
                    <Grid container>
                        <Grid item xs={12}>
                            <Grid item xs={12}>
                                <TextField
                                    label={"Codice"}
                                    value={this.state.newRoom.code}
                                    onChange={(value) => this.updateRoom({ ...this.state.newRoom, code: value })}
                                /></Grid>
                            <TextField
                                label={"Descrizione"}
                                value={this.state.newRoom.description}
                                onChange={(value) => this.updateRoom({ ...this.state.newRoom, description: value })}
                            />

                        </Grid>
                    </Grid>
                </DialogContent >
                <DialogActions className={this.props.classes.reservationSlotDetailDialogActions}>
                    <ConfirmButton disabled={!this.checkRoomInvalid()} onClick={() => this.props.onConfirm(this.state.newRoom)} text={"Aggiungi"} />
                    <CancelButton onClick={this.props.onCancel} />
                </DialogActions>
            </Dialog >
        );
    }
}

export default withStyles(styles as any)(WithMediaQuery(AddRoomDialog)) as React.ComponentType<IInnerProps>;